import { useEffect } from 'react';

const importScript = (src, cb) => {
  return new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${src}"]`);

    // 1. If script already exists in the DOM
    if (existing) {
      if (existing.dataset.loaded === "true") {
        cb ? cb() : resolve(); // Already fully loaded
      } else {
        // Still loading: wait for it to finish
        existing.addEventListener("load", cb ? cb : resolve);
        existing.addEventListener("error", reject);
      }
      return;
    }

    // 2. If script does not exist, create it
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.dataset.loaded = "false";

    script.onload = () => {
      script.dataset.loaded = "true";
      cb ? cb() : resolve();
    };

    script.onerror = () => {
      console.error(`[EditorHelpPage] Failed to load script: ${src}`);
      reject(new Error(`Failed to load ${src}`));
    };

    document.body.appendChild(script);
  });
};

/*const importScript = (src, cb) => {
  if (document.querySelector(`script[src="${src}"]`)) {
    const existing = document.querySelector(`script[src="${src}"]`);
    if (existing.dataset.loaded === "true") {
      cb();
    } else {
      existing.addEventListener("load", cb);
    }
    return;
  }

  const script = document.createElement("script");
  script.src = src;
  script.async = true;
  script.dataset.loaded = "false";

  script.onload = () => {
    script.dataset.loaded = "true";
    cb();
  };

  script.onerror = () => {
    console.error(`[EditorHelpPage] Failed to load script: ${src}`);
  };

  document.body.appendChild(script);
}*/

export default importScript;